import * as tslib_1 from "tslib";
import { Base } from '../base-component';
import './profile-tile-item.component.scss';
var ProfileTileItem = /** @class */ (function (_super) {
    tslib_1.__extends(ProfileTileItem, _super);
    function ProfileTileItem(element) {
        return _super.call(this, element) || this;
    }
    ProfileTileItem.prototype.init = function () {
    };
    ProfileTileItem.prototype.bindEvents = function () {
    };
    return ProfileTileItem;
}(Base));
export { ProfileTileItem };



//////////////////
// WEBPACK FOOTER
// ./components/profile-tile-item/profile-tile-item.component.ts
// module id = 596
// module chunks = 0